





























































import TechnologyFinite from '@/components/reports/TechnologyFinite.vue';
import TechnologyIndefinite from '@/components/reports/TechnologyIndefinite.vue';

export default {
    name: 'TechnologyValuationMultiples',
    components: { TechnologyFinite, TechnologyIndefinite },
    props: {
        normalizeData: { type: Function },
        singleRecordData: {},
    },
};
